export default {
  id: 'AttendanceScanMessage',
  code: 'CN',
  text: {
    "Continue Attendance Scan": "进行扫码签到",
    'Attention Notes': '注意事项',
    'Please make sure that the scanner is connected to the computer that is using ClasstopBase. The computer will recognize the Scanner when you plug it into a USB slot. Make sure the light on the scanner tunes on after being plugged in.': '请确认扫码仪已成功连接到本电脑，电脑显示有 USB Key Module 设备连接，并且扫码仪指示灯点亮',
    'When using Smart Check In and Scan Payment functions, please log in to ClasstopBase on an Administrator account with the corresponding permissions to operate these functions.': '在使用智能签到以及扫码付款时，确保是以校长账户或拥有相应权限的管理员账户登录',
    'Smart Check In will sign in students for a class that is about to start, or one that is already in progress (in which case the student will be marked as late). However, if the lesson has already finished, students can not sign in with Smart Check In. You can manually sign in the student in the Class Channel on ClasstopBase.': '智能签到会对该学生当天、未签到的、距离当时时间最近的一节还未上的课或正在上的课（做迟到处理）进行签到，已经下课的无法签到，可在班级频道内手动补签到',
    'When using Smart Check In and Scan Payment functions on your browser, please make sure that the corresponding window remains open, and the browser or tab is not closed, or minimized during use.': '请在智能签到以及扫码付款时，确保扫码界面打开，浏览器必须在当前页面，不能最小化',
    'Please click “I Understand” to start scanning.': '请点击“我知道了”进去扫码界面',
    'Don’t remind me next time': '下次不要再提醒我',
    'I understand': '我知道了',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/AttendanceScanMessage/locale.js